import { jitsuAnalytics } from '@jitsu/js'
import { BotsUserAgents } from '@marketplace/config/bots.js'
import { installJitsuFanOut } from '@shared/segment/jitsuFanOut.js'

global.hasDelayedTracking = true

// The starting point of the require is a parent folder, so the ../../ is correct.
require('../../shared/segment/checkoutTracking.js')
require('../../shared/segment/createSession.js')
require('../../shared/segment/startAnalytics.js')

const botsRegex = new RegExp(BotsUserAgents.join('|'), 'i')

/**
 * Initialize Segment, then (when enabled) Jitsu alongside it and wire up the
 * fan-out shim. The Jitsu wiring lives in the shared `installJitsuFanOut`
 * helper so every Segment-loading surface behaves identically.
 * @param {object} context
 * @param {object} context.$config
 */
export default function ({ $config }) {
    const segmentEnabled =
        $config?.analyticsSegmentEnabled !== false && !!$config?.segmentWriteKey
    const jitsuEnabled = !!(
        $config?.jitsuEnabled && $config?.jitsuBrowserWriteKey
    )

    if (!segmentEnabled && !jitsuEnabled) {
        return
    }

    if (segmentEnabled) {
        /* eslint-disable */
        !function(){
            var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
        }}();
        /* eslint-enable */
    } else {
        // Jitsu-only: install an analytics stub so call sites keep working.
        // We replace it with the real fan-out shim below once Jitsu is ready.
        const stub = []
        stub.methods = [
            'track',
            'identify',
            'page',
            'group',
            'ready',
            'reset',
            'alias',
        ]
        stub.factory =
            (m) =>
            (...args) =>
                stub.push([m, ...args])
        stub.methods.forEach((m) => (stub[m] = stub.factory(m)))
        window.analytics = stub
    }

    window.onNuxtReady(() => {
        const isBot = botsRegex?.test(navigator.userAgent)

        if (isBot) {
            return
        }

        if (segmentEnabled) {
            window.analytics.load($config.segmentWriteKey)
        }

        installJitsuFanOut({
            jitsuAnalytics,
            host: $config.jitsuHost,
            writeKey: $config.jitsuBrowserWriteKey,
            segmentEnabled,
            jitsuEnabled,
        })
    })
}
